import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Instagram, MapPin, Star, Gift, Award, Shield, Clock, Users, ChevronRight, Sparkles } from 'lucide-react';

const Home = () => {
  const [currentReview, setCurrentReview] = useState(0);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    // Sayfa açılışta hep en üstten başlasın
    window.scrollTo(0, 0);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    const timer = setTimeout(() => {
      setShowIntro(false);
      window.scrollTo(0, 0);
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  const phoneNumber = '0546 193 90 16';
  const whatsappNumber = '905461939016';
  const telNumber = '05461939016';
  const businessInstagram = 'purelifebursa';

  const services = [
    {
      title: 'Klasik Masaj',
      desc: 'Geleneksel İsveç masaj teknikleriyle vücudunuzdaki gerginlikleri çözün, kan dolaşımını canlandırın ve günün stresinden tamamen arının.',
      duration: '60 dakika'
    },
    {
      title: 'Soft Masaj',
      desc: 'Hafif, akıcı ve sakinleştirici dokunuşlarla zihninizi dinginleştirin. Stresi eriten zarif bir rahatlama seansı sizi bekliyor.',
      duration: '60 dakika'
    },
    {
      title: 'Mix Masaj',
      desc: 'Klasik, refleksoloji ve aromaterapi tekniklerinin uyumlu birleşimiyle eşsiz bir denge yakalayın. Tam vücut yenilenmesi için ideal.',
      duration: '90 dakika'
    },
    {
      title: 'Medikal Masaj',
      desc: 'Sertifikalı uzmanlarımız tarafından uygulanan, kas-iskelet rahatsızlıklarına yönelik terapötik masaj. Ağrılarınıza profesyonel çözüm.',
      duration: '75 dakika'
    }
  ];

  const reviews = [
    { name: 'Mehmet Kaya', rating: 5, comment: 'Uzun zamandır yaşadığım sırt ağrıları için geldim ve çok memnun kaldım. Terapistler çok deneyimli, ortam son derece hijyenik.' },
    { name: 'Burak Şahin', rating: 5, comment: 'Mekânın ambiyansı, müziği, kokusu... Her detay düşünülmüş. Kesinlikle yeniden geleceğim, tavsiye ederim.' },
    { name: 'Ali Demir', rating: 5, comment: 'Görükle\'de bu kalitede premium bir spa olduğunu bilmiyordum. Profesyonel hizmet, temiz ortam, fiyat-performans mükemmel.' },
    { name: 'Emre Yıldız', rating: 5, comment: 'Spor sonrası kas ağrıları için medikal masaj aldım. İnanılmaz rahatladım, terapist gerçekten işini biliyor.' },
    { name: 'Can Aydın', rating: 5, comment: 'Klasik masaj seansı süper geçti. Stresin tamamen erimesi 60 dakika sürdü. Bursa\'nın en iyilerinden.' },
    { name: 'Murat Öztürk', rating: 5, comment: 'Eşime hediye olarak %20 indirim kuponu aldım. İkimiz de çok memnun kaldık. Personel ilgili ve nazik.' },
    { name: 'Cem Arslan', rating: 5, comment: 'Mix masaj denedim, harikaydı. Aromaterapi yağları çok kaliteli, ortam çok dingin. Kesinlikle tavsiye.' },
    { name: 'Serkan Polat', rating: 5, comment: 'İş stresinden kurtulmak için geldim, gerçekten kendinizi yenilenmiş hissediyorsunuz. Görükle\'de tek bu kaliteli yer.' },
    { name: 'Tolga Korkmaz', rating: 5, comment: 'Soft masaj inanılmaz dinginleştiriciydi. Hafta içi yoğunluğun ardından mükemmel bir mola oldu.' },
    { name: 'Fatih Çelik', rating: 5, comment: 'Hijyen standartları üst düzey, terapistler nazik ve uzman. Fiyatlar kaliteye göre çok uygun.' },
    { name: 'Hasan Acar', rating: 5, comment: 'Boyun fıtığım için medikal masaj seansları aldım. Doktorum bile farkı söyledi. Sağ olun.' },
    { name: 'Ahmet Erdem', rating: 5, comment: 'Mekânda lüks otel ambiyansı var. Servis kalitesi beklentimin çok üzerinde, fiyatlar gayet makul.' },
    { name: 'Yusuf Kara', rating: 5, comment: '90 dakikalık mix masaj uçtum dersem yalan olmaz. Profesyonellik adına 5 yıldız az.' },
    { name: 'Kaan Bilgin', rating: 5, comment: 'Doğum günümde kendime hediye ettim, çok iyi etmişim. Ortam son derece şık ve premium.' },
    { name: 'Berk Yılmaz', rating: 5, comment: 'Bursa\'nın en kaliteli masaj salonu. Görükle\'de olması büyük şans. Düzenli müşteri oldum, tavsiye ederim.' }
  ];

  const features = [
    { icon: Award, title: 'Uzman Terapistler', desc: 'Sertifikalı, deneyimli ve özenle seçilmiş profesyonel kadro' },
    { icon: Shield, title: '%100 Hijyen', desc: 'Her seans öncesi özel sterilizasyon ve tek kullanımlık ekipman' },
    { icon: Clock, title: 'Esnek Randevu', desc: 'Günün her saatinde size uygun premium randevu imkânı' },
    { icon: Users, title: '10.000+ Misafir', desc: 'On binlerce kişinin tercih ettiği güvenilir spa adresi' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [reviews.length]);

  useEffect(() => {
    const timer1 = setInterval(() => {
      setCount1(prev => prev < 10000 ? prev + 150 : 10000);
    }, 20);
    const timer2 = setInterval(() => {
      setCount2(prev => prev < 100 ? prev + 1 : 100);
    }, 30);
    return () => {
      clearInterval(timer1);
      clearInterval(timer2);
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFFFF', color: '#0B0B0B' }}>

      {/* Premium Intro Animation */}
      {showIntro && (
        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
          style={{ backgroundColor: '#0B0B0B' }}>

          {/* Video / Image background with Ken Burns effect */}
          <div className="absolute inset-0 overflow-hidden">
            <video
              autoPlay
              loop
              muted
              playsInline
              poster="https://images.pexels.com/photos/3865792/pexels-photo-3865792.jpeg?auto=compress&cs=tinysrgb&w=1920"
              className="absolute inset-0 w-full h-full object-cover ken-burns"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}>
              <source src="https://videos.pexels.com/video-files/3195391/3195391-hd_1920_1080_25fps.mp4" type="video/mp4" />
            </video>
            {/* Fallback image (always rendered behind video) */}
            <img
              src="https://images.pexels.com/photos/3865792/pexels-photo-3865792.jpeg?auto=compress&cs=tinysrgb&w=1920"
              alt=""
              className="absolute inset-0 w-full h-full object-cover ken-burns -z-10"
            />
          </div>

          {/* Dark + gold overlay */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(11,11,11,0.85) 0%, rgba(11,11,11,0.75) 50%, rgba(11,11,11,0.92) 100%)' }}></div>

          {/* Gold radial glow */}
          <motion.div
            className="absolute inset-0 pointer-events-none"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            style={{ background: 'radial-gradient(circle at center, rgba(212,175,55,0.18) 0%, transparent 60%)' }}
          />

          {/* Gold corner ornaments */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, delay: 0.3 }}
            className="absolute top-8 left-8 w-20 h-20 border-t-2 border-l-2 border-[#D4AF37] hidden md:block"></motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, delay: 0.3 }}
            className="absolute top-8 right-8 w-20 h-20 border-t-2 border-r-2 border-[#D4AF37] hidden md:block"></motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, delay: 0.3 }}
            className="absolute bottom-8 left-8 w-20 h-20 border-b-2 border-l-2 border-[#D4AF37] hidden md:block"></motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, delay: 0.3 }}
            className="absolute bottom-8 right-8 w-20 h-20 border-b-2 border-r-2 border-[#D4AF37] hidden md:block"></motion.div>

          {/* Center content */}
          <div className="relative text-center px-6 max-w-3xl mx-auto z-10">

            {/* Top gold line */}
            <motion.div
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: '160px', opacity: 1 }}
              transition={{ duration: 1.2, delay: 0.4, ease: 'easeOut' }}
              className="h-px gold-gradient-bg mx-auto mb-10"
            />

            {/* Tagline */}
            <motion.p
              initial={{ opacity: 0, y: 20, filter: 'blur(8px)' }}
              animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
              transition={{ duration: 1, delay: 0.7 }}
              className="text-[10px] md:text-xs tracking-[0.6em] uppercase gold-gradient-text font-semibold mb-8">
              ✦ Premium Masaj Salonu ✦
            </motion.p>

            {/* Logo / Brand name with letter reveal */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 1.0 }}
              className="mb-4">
              <motion.h1
                initial={{ letterSpacing: '0.6em', opacity: 0 }}
                animate={{ letterSpacing: '0.12em', opacity: 1 }}
                transition={{ duration: 1.8, delay: 1.0, ease: [0.25, 0.46, 0.45, 0.94] }}
                className="text-3xl md:text-5xl lg:text-6xl font-extralight text-white uppercase mb-1">
                Görükle
              </motion.h1>
              <motion.h1
                initial={{ letterSpacing: '0.6em', opacity: 0 }}
                animate={{ letterSpacing: '0.18em', opacity: 1 }}
                transition={{ duration: 1.8, delay: 1.4, ease: [0.25, 0.46, 0.45, 0.94] }}
                className="text-4xl md:text-6xl lg:text-7xl font-light gold-gradient-text uppercase">
                Masaj Salonu
              </motion.h1>
            </motion.div>

            {/* Subtitle location */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 2.4 }}
              className="flex items-center justify-center gap-3 mb-8">
              <div className="w-8 h-px bg-[#D4AF37]/60"></div>
              <p className="text-[10px] md:text-xs tracking-[0.5em] uppercase text-[#D4AF37]">
                Bursa · Görükle · Est. 2014
              </p>
              <div className="w-8 h-px bg-[#D4AF37]/60"></div>
            </motion.div>

            {/* Bottom gold line */}
            <motion.div
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: '160px', opacity: 1 }}
              transition={{ duration: 1.2, delay: 2.8, ease: 'easeOut' }}
              className="h-px gold-gradient-bg mx-auto mb-12"
            />

            {/* Loading bar */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 3.0 }}
              className="relative w-48 md:w-64 mx-auto h-px bg-[#D4AF37]/15 overflow-hidden">
              <motion.div
                initial={{ x: '-100%' }}
                animate={{ x: '100%' }}
                transition={{ duration: 2.5, delay: 3.0, ease: 'easeInOut' }}
                className="absolute inset-0 gold-gradient-bg"
              />
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 3.4 }}
              className="text-[9px] tracking-[0.4em] uppercase text-[#737373] mt-4">
              Hoş geldiniz
            </motion.p>
          </div>

          {/* Bottom: Project Bana Bi Media credit */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 4.5 }}
            className="absolute bottom-8 md:bottom-10 left-0 right-0 z-20 flex justify-center px-6">
            <a
              href="https://banabimedia.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-5 py-2.5 border border-[#D4AF37]/40 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 backdrop-blur-sm transition-all duration-300"
              data-testid="intro-banabimedia-link"
              aria-label="Bana Bi Media web sitesi">
              <span className="text-[9px] md:text-[10px] tracking-[0.4em] uppercase text-[#A3A3A3] group-hover:text-[#D4AF37] transition-colors">
                Project
              </span>
              <span className="w-px h-3 bg-[#D4AF37]/40"></span>
              <span className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase gold-gradient-text">
                Bana Bi Media
              </span>
              <ChevronRight size={12} className="text-[#D4AF37] group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>
        </motion.div>
      )}

      {/* Floating Buttons - WhatsApp ile gerçek logo */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Merhaba, Görükle Masaj Salonu için randevu almak istiyorum.')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 md:p-5 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 group"
        data-testid="whatsapp-button"
        aria-label="WhatsApp ile İletişim">
        {/* WhatsApp official logo SVG */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-7 h-7 md:w-8 md:h-8 fill-current">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
        </svg>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
      </a>

      <a
        href={`tel:${telNumber}`}
        className="fixed bottom-24 right-6 z-50 gold-gradient-bg text-[#0B0B0B] p-4 md:p-5 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300"
        data-testid="phone-button"
        aria-label="Telefon ile Ara">
        <Phone size={26} strokeWidth={2.2} />
      </a>

      {/* Header */}
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.92)', borderBottom: '1px solid rgba(212, 175, 55, 0.25)' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12 py-4 md:py-6 flex items-center justify-between">
          <h1 className="text-sm md:text-2xl font-light tracking-wide text-[#0B0B0B] uppercase truncate pr-2">
            Görükle Masaj Salonu
          </h1>
          <div className="flex items-center gap-3 md:gap-6 flex-shrink-0">
            <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="text-[#525252] hover:text-[#D4AF37] transition-colors hidden md:inline">
              <MessageCircle size={20} strokeWidth={1.5} />
            </a>
            <a href={`https://instagram.com/${businessInstagram}`} target="_blank" rel="noopener noreferrer" className="text-[#525252] hover:text-[#D4AF37] transition-colors hidden md:inline">
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a href={`tel:${telNumber}`}>
              <button className="gold-gradient-bg text-[#0B0B0B] px-4 md:px-6 py-2 md:py-2.5 font-medium tracking-[0.15em] md:tracking-widest uppercase text-[10px] md:text-sm hover:opacity-90 transition-all duration-300 whitespace-nowrap" data-testid="header-cta">
                Randevu Al
              </button>
            </a>
          </div>
        </div>
      </motion.header>

      {/* Hero - Premium Editorial Layout */}
      <section className="relative flex items-center overflow-hidden pt-28 pb-16 lg:min-h-screen lg:pt-0 lg:pb-0" style={{ backgroundColor: '#FAFAF8' }}>
        {/* Decorative gold elements */}
        <div className="absolute top-0 right-0 w-1/3 h-full opacity-30 hidden lg:block">
          <div className="absolute top-1/4 right-12 w-64 h-64 rounded-full" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.4) 0%, transparent 70%)' }}></div>
        </div>
        <div className="absolute bottom-0 left-0 w-1/4 h-1/2 opacity-20 hidden lg:block">
          <div className="absolute bottom-12 left-12 w-48 h-48 rounded-full" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.5) 0%, transparent 70%)' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-5 md:px-12 py-0 lg:py-20 w-full relative z-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

            {/* Left: Text content */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, delay: 0.2 }}
              className="relative">

              {/* Top tag */}
              <div className="inline-flex items-center gap-3 mb-6 md:mb-8">
                <div className="w-10 md:w-12 h-px gold-gradient-bg"></div>
                <span className="text-[9px] md:text-xs tracking-[0.4em] md:tracking-[0.5em] uppercase gold-gradient-text font-semibold">
                  Premium Masaj Salonu
                </span>
              </div>

              {/* Headline */}
              <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight tracking-tight text-[#0B0B0B] mb-2 md:mb-3 leading-[1.05]">
                Bedeninizin
              </h2>
              <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight tracking-tight text-[#0B0B0B] mb-2 md:mb-3 leading-[1.05]">
                <span className="italic font-light text-[#737373]">ve</span> Ruhunuzun
              </h2>
              <h2 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-light tracking-tight gold-gradient-text mb-6 md:mb-8 leading-[1.05]">
                Sığınağı.
              </h2>

              {/* Description */}
              <p className="text-sm md:text-lg font-light leading-[1.8] text-[#525252] mb-8 md:mb-10 max-w-xl">
                Görükle'nin kalbinde, sertifikalı uzman terapistler eşliğinde sunulan premium masaj deneyimi. Kendinize özel bir mola için sizi bekliyoruz.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-10 md:mb-12">
                <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Merhaba, Görükle Masaj Salonu için randevu almak istiyorum.')}`} target="_blank" rel="noopener noreferrer">
                  <button className="group gold-gradient-bg text-[#0B0B0B] px-8 md:px-10 py-4 md:py-5 font-bold tracking-[0.15em] md:tracking-[0.18em] uppercase text-[11px] md:text-xs hover:opacity-90 transition-all duration-300 shadow-2xl inline-flex items-center justify-center gap-2 md:gap-3 w-full sm:w-auto" data-testid="hero-cta">
                    <MessageCircle size={14} />
                    Hemen Randevu Al
                    <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </a>
                <a href={`tel:${telNumber}`}>
                  <button className="bg-transparent border border-[#0B0B0B] text-[#0B0B0B] px-8 md:px-10 py-4 md:py-5 font-bold tracking-[0.15em] md:tracking-[0.18em] uppercase text-[11px] md:text-xs hover:bg-[#0B0B0B] hover:text-white transition-all duration-300 inline-flex items-center justify-center gap-2 md:gap-3 w-full sm:w-auto">
                    <Phone size={14} />
                    {phoneNumber}
                  </button>
                </a>
              </div>

              {/* Trust badges */}
              <div className="flex flex-wrap items-center gap-4 md:gap-8 pt-6 md:pt-8 border-t border-[#D4AF37]/20">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="fill-[#D4AF37] text-[#D4AF37]" size={12} />
                    ))}
                  </div>
                  <span className="text-[10px] md:text-xs tracking-wider text-[#525252]">5.0 Google</span>
                </div>
                <div className="w-px h-4 md:h-6 bg-[#D4AF37]/30"></div>
                <div className="flex items-center gap-2">
                  <Award size={14} className="text-[#D4AF37]" />
                  <span className="text-[10px] md:text-xs tracking-wider text-[#525252]">10.000+ Misafir</span>
                </div>
                <div className="w-px h-4 md:h-6 bg-[#D4AF37]/30 hidden sm:block"></div>
                <div className="flex items-center gap-2">
                  <Shield size={14} className="text-[#D4AF37]" />
                  <span className="text-[10px] md:text-xs tracking-wider text-[#525252]">10+ Yıl Tecrübe</span>
                </div>
              </div>
            </motion.div>

            {/* Right: Image with overlay card */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, delay: 0.4 }}
              className="relative hidden lg:block">

              {/* Main image */}
              <div className="relative aspect-[4/5] overflow-hidden shadow-2xl" style={{ border: '1px solid rgba(212, 175, 55, 0.3)' }}>
                <img
                  src="https://images.pexels.com/photos/3865792/pexels-photo-3865792.jpeg?auto=compress&cs=tinysrgb&w=1600"
                  alt="Görükle Masaj Salonu - Premium Spa"
                  className="w-full h-full object-cover"
                />
                {/* Soft gradient overlay for depth */}
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 50%, rgba(11,11,11,0.3) 100%)' }}></div>
              </div>

              {/* Floating stats card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.9 }}
                className="absolute -bottom-8 -left-8 bg-white p-6 shadow-2xl"
                style={{ border: '1px solid rgba(212, 175, 55, 0.3)' }}>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 gold-gradient-bg flex items-center justify-center flex-shrink-0">
                    <Sparkles size={22} className="text-[#0B0B0B]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <p className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mb-1">İlk Randevu</p>
                    <p className="text-2xl font-light text-[#0B0B0B] leading-none">
                      <span className="gold-gradient-text font-bold">%20</span> İndirim
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* Top right gold corner accent */}
              <div className="absolute -top-6 -right-6 w-32 h-32 hidden md:block">
                <div className="absolute top-0 right-0 w-full h-full border-t-2 border-r-2 border-[#D4AF37]"></div>
              </div>
              <div className="absolute -bottom-6 -right-6 w-24 h-24 hidden md:block">
                <div className="absolute bottom-0 right-0 w-full h-full border-b-2 border-r-2 border-[#D4AF37] gold-gradient-bg opacity-90"></div>
              </div>
            </motion.div>

            {/* Mobile image */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.4 }}
              className="lg:hidden">
              <div className="relative aspect-[4/3] overflow-hidden shadow-xl" style={{ border: '1px solid rgba(212, 175, 55, 0.3)' }}>
                <img
                  src="https://images.pexels.com/photos/3865792/pexels-photo-3865792.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  alt="Görükle Masaj Salonu"
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>

          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
          <div className="flex flex-col items-center gap-2">
            <span className="text-[10px] tracking-[0.4em] uppercase text-[#737373]">Keşfedin</span>
            <div className="w-px h-12 bg-gradient-to-b from-[#D4AF37] to-transparent"></div>
          </div>
        </div>
      </section>

      {/* Stats - Minimal Premium Trust Bar */}
      <section className="relative" style={{ backgroundColor: '#0B0B0B' }}>
        {/* Top gold hairline */}
        <div className="absolute top-0 left-0 right-0 h-px gold-gradient-bg"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px gold-gradient-bg"></div>

        <div className="max-w-7xl mx-auto px-5 md:px-12 py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4">
            {[
              { value: `${count1.toLocaleString()}+`, label: 'Mutlu Misafir' },
              { value: `${count2}%`, label: 'Memnuniyet' },
              { value: '10+', label: 'Yıllık Tecrübe' },
              { value: '5★', label: 'Google Puanı' }
            ].map((stat, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: idx * 0.08 }}
                viewport={{ once: true }}
                className={`text-center px-2 md:px-4 py-5 md:py-2 ${
                  idx !== 3 ? 'md:border-r' : ''
                } ${idx === 0 || idx === 2 ? 'border-r md:border-r' : ''} ${idx < 2 ? 'border-b md:border-b-0' : ''}`}
                style={{ borderColor: 'rgba(212, 175, 55, 0.15)' }}>
                <div className="text-2xl md:text-4xl lg:text-5xl font-light text-[#D4AF37] mb-2 leading-none tracking-tight">
                  {stat.value}
                </div>
                <div className="text-[9px] md:text-xs font-medium tracking-[0.2em] md:tracking-[0.3em] uppercase text-[#A3A3A3]">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Hakkımızda */}
      <section className="py-16 md:py-28" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-20">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text mb-4">
              Hakkımızda
            </p>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Premium Spa Deneyimi
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9 }}
              viewport={{ once: true }}
              className="relative">
              <div className="aspect-[4/5] overflow-hidden" style={{ border: '1px solid rgba(212, 175, 55, 0.4)' }}>
                <img
                  src="https://images.pexels.com/photos/3865711/pexels-photo-3865711.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  alt="Görükle Masaj Salonu - Premium Masaj Deneyimi"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 gold-gradient-bg text-[#0B0B0B] p-6 hidden md:block shadow-xl">
                <div className="text-4xl font-light leading-none mb-1">10+</div>
                <p className="text-[10px] tracking-[0.3em] uppercase font-medium">Yıllık Tecrübe</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9 }}
              viewport={{ once: true }}
              className="space-y-6">
              <p className="text-[10px] tracking-[0.4em] uppercase gold-gradient-text font-semibold">— Masaj Anlayışını Yeniden Tanımlıyoruz</p>
              <h3 className="text-2xl md:text-3xl font-light text-[#0B0B0B] leading-tight">
                Görükle'nin kalbinde, dingin bir <span className="gold-gradient-text font-medium">premium kaçış noktası.</span>
              </h3>
              <p className="text-base font-light leading-[1.9] text-[#525252]">
                <strong className="text-[#0B0B0B] font-medium">Görükle Masaj Salonu</strong>, Bursa Görükle bölgesinin en seçkin masaj salonu adresidir. 10 yılı aşkın tecrübemizle, on binlerce misafire unutulmaz rahatlama anları yaşattık.
              </p>
              <p className="text-base font-light leading-[1.9] text-[#525252]">
                Oruç Plus binasında konumlanan salonumuz; modern mimarisi, hijyenik standartları ve özenle seçilmiş aroma terapi yağlarıyla benzersiz bir kaçış noktası sunar. Sertifikalı terapistlerimiz her misafire özel ritüeller hazırlar.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-4">
                <div className="border-l-2 border-[#D4AF37] pl-5">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mb-1">Felsefe</div>
                  <div className="text-sm text-[#0B0B0B] font-medium">Sessizlik & Denge</div>
                </div>
                <div className="border-l-2 border-[#D4AF37] pl-5">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mb-1">Standart</div>
                  <div className="text-sm text-[#0B0B0B] font-medium">Avrupa Spa Sertifikalı</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Neden Biz? */}
      <section className="py-16 md:py-28" style={{ backgroundColor: '#FAFAFA', borderTop: '1px solid rgba(212, 175, 55, 0.2)', borderBottom: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-20">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text mb-4">
              Neden Biz?
            </p>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Farkımızı Yaşayın
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="group relative p-8 bg-white hover:shadow-xl transition-all duration-500"
                style={{ border: '1px solid rgba(212, 175, 55, 0.25)' }}>
                <div className="w-16 h-16 gold-gradient-bg mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                  <feature.icon className="text-[#0B0B0B]" size={28} strokeWidth={1.5} />
                </div>
                <h3 className="text-lg md:text-xl font-medium text-[#0B0B0B] mb-3 text-center tracking-wide">{feature.title}</h3>
                <p className="text-sm text-[#525252] leading-relaxed font-light text-center">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-16 md:py-28" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-20">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text mb-4">
              Hizmetlerimiz
            </p>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Premium Masaj Terapileri
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {services.map((service, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="group relative bg-white p-8 md:p-10 hover:shadow-xl transition-all duration-500"
                style={{ border: '1px solid rgba(212, 175, 55, 0.3)' }}>
                <div className="absolute top-0 left-0 w-12 h-12 border-t border-l border-[#D4AF37] group-hover:w-16 group-hover:h-16 transition-all duration-500"></div>
                <div className="absolute bottom-0 right-0 w-12 h-12 border-b border-r border-[#D4AF37] group-hover:w-16 group-hover:h-16 transition-all duration-500"></div>

                <div className="flex items-start justify-between mb-5">
                  <div>
                    <p className="text-[10px] md:text-xs tracking-[0.3em] uppercase gold-gradient-text font-semibold mb-2">
                      Premium Terapi
                    </p>
                    <h3 className="text-2xl md:text-3xl font-light text-[#0B0B0B] tracking-wide">
                      {service.title}
                    </h3>
                  </div>
                  <div className="text-right">
                    <div className="inline-block gold-gradient-bg text-[#0B0B0B] px-3 py-1 text-[10px] tracking-[0.2em] uppercase font-semibold">
                      {service.duration}
                    </div>
                  </div>
                </div>

                <div className="w-12 h-px bg-[#D4AF37] mb-5"></div>

                <p className="text-base font-light leading-[1.9] text-[#525252] mb-8">
                  {service.desc}
                </p>

                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`Merhaba, ${service.title} için randevu almak istiyorum.`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-cta-${idx}`}>
                  <button className="group/btn w-full bg-transparent border border-[#0B0B0B] text-[#0B0B0B] px-6 py-3 font-semibold tracking-[0.18em] uppercase text-xs hover:bg-[#0B0B0B] hover:text-white transition-all duration-300 inline-flex items-center justify-center gap-3">
                    <MessageCircle size={14} />
                    Randevu Al
                    <ChevronRight size={14} className="group-hover/btn:translate-x-1 transition-transform" />
                  </button>
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Hediye Kuponu - Premium Animated Voucher */}
      <section className="py-16 md:py-28 relative overflow-hidden" style={{ backgroundColor: '#FAFAFA', borderTop: '1px solid rgba(212, 175, 55, 0.2)', borderBottom: '1px solid rgba(212, 175, 55, 0.2)' }}>
        {/* Decorative gold radial */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] opacity-30 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.25) 0%, transparent 70%)' }}></div>

        <div className="max-w-5xl mx-auto px-5 md:px-12 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-14">
            <div className="inline-flex items-center gap-3 mb-4">
              <div className="w-10 h-px gold-gradient-bg"></div>
              <Gift size={18} className="text-[#D4AF37]" strokeWidth={1.5} />
              <span className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text">
                Hediye Kuponu
              </span>
              <Gift size={18} className="text-[#D4AF37]" strokeWidth={1.5} />
              <div className="w-10 h-px gold-gradient-bg"></div>
            </div>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Sevdikleriniz İçin <span className="gold-gradient-text font-medium">Premium Hediye</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
            viewport={{ once: true }}
            className="relative">

            {/* Outer glowing ring */}
            <div className="absolute -inset-2 gold-gradient-bg blur-2xl opacity-40"></div>

            {/* Coupon card */}
            <div className="relative bg-[#0B0B0B] overflow-hidden shadow-[0_30px_80px_-20px_rgba(212,175,55,0.4)]" style={{ border: '1px solid rgba(212, 175, 55, 0.5)' }}>
              {/* Gold accent line top */}
              <div className="h-1 gold-gradient-bg"></div>

              {/* Decorative pattern */}
              <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(212,175,55,.6) 35px, rgba(212,175,55,.6) 70px)' }}></div>

              {/* Corner decorations */}
              <div className="absolute top-4 left-4 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] z-10"></div>
              <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-[#D4AF37] z-10"></div>
              <div className="absolute bottom-4 left-4 w-12 h-12 border-b-2 border-l-2 border-[#D4AF37] z-10"></div>
              <div className="absolute bottom-4 right-4 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] z-10"></div>

              {/* Perforated divider effect */}
              <div className="hidden md:block absolute left-[55%] top-12 bottom-12 w-px" style={{ borderLeft: '2px dashed rgba(212,175,55,0.3)' }}>
                <div className="absolute -left-3 -top-3 w-6 h-6 rounded-full bg-[#FAFAFA]" style={{ border: '1px solid rgba(212,175,55,0.5)' }}></div>
                <div className="absolute -left-3 -bottom-3 w-6 h-6 rounded-full bg-[#FAFAFA]" style={{ border: '1px solid rgba(212,175,55,0.5)' }}></div>
              </div>

              <div className="grid md:grid-cols-[1.2fr,1fr] relative z-10">
                {/* Left side - Coupon details */}
                <div className="p-7 md:p-14 border-b md:border-b-0 border-[#D4AF37]/20">
                  <div className="flex items-center gap-3 mb-8">
                    <div className="w-12 h-12 gold-gradient-bg flex items-center justify-center">
                      <Gift size={22} className="text-[#0B0B0B]" strokeWidth={2} />
                    </div>
                    <div>
                      <p className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] font-bold">
                        Premium Gift Voucher
                      </p>
                      <p className="text-[9px] tracking-[0.3em] uppercase text-[#737373] mt-1">
                        Görükle Masaj Salonu · 2026
                      </p>
                    </div>
                  </div>

                  <div className="flex items-end gap-2 mb-4">
                    <h3 className="text-6xl sm:text-7xl md:text-9xl font-extralight gold-gradient-text leading-none tracking-tight">
                      20
                    </h3>
                    <span className="text-3xl sm:text-4xl md:text-6xl font-light gold-gradient-text mb-2 md:mb-3">%</span>
                  </div>

                  <p className="text-lg md:text-3xl font-light text-white mb-5 md:mb-6 tracking-wide">
                    İndirim <span className="italic text-[#D4AF37]">Hediyesi</span>
                  </p>

                  <div className="w-16 md:w-20 h-px gold-gradient-bg mb-5 md:mb-6"></div>

                  <p className="text-xs md:text-base font-light leading-[1.8] md:leading-[1.9] text-[#A3A3A3] mb-6 md:mb-8">
                    İlk ziyaretinizde <strong className="text-white font-medium">tüm masaj hizmetlerinde</strong> geçerli özel hediye kuponu. Sevdiklerinize de hediye edebilirsiniz.
                  </p>

                  <div className="space-y-3">
                    {['Tüm masaj hizmetlerinde geçerli', 'Hediye olarak gönderilebilir', 'Yeni misafirlerimize özel'].map((item, idx) => (
                      <motion.div
                        key={idx}
                        initial={{ opacity: 0, x: -10 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: idx * 0.15 }}
                        viewport={{ once: true }}
                        className="flex items-center gap-3">
                        <div className="w-5 h-5 gold-gradient-bg rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-[#0B0B0B] text-[10px] font-bold">✓</span>
                        </div>
                        <span className="text-xs tracking-[0.15em] uppercase text-[#D4D4D4]">{item}</span>
                      </motion.div>
                    ))}
                  </div>
                </div>

                {/* Right side - Coupon code & CTAs */}
                <div className="p-7 md:p-12 flex flex-col justify-center bg-gradient-to-b from-[#0F0F0F] to-[#0B0B0B] relative">
                  {/* Star decorations */}
                  <div className="absolute top-8 right-8">
                    <Sparkles size={16} className="text-[#D4AF37] animate-pulse" />
                  </div>
                  <div className="absolute bottom-8 left-8">
                    <Star size={12} className="text-[#D4AF37] fill-[#D4AF37]" />
                  </div>

                  <div className="text-center mb-10">
                    <p className="text-[10px] tracking-[0.4em] uppercase text-[#A3A3A3] mb-5">— Kupon Kodu —</p>

                    <motion.div
                      initial={{ scale: 0.9, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      transition={{ duration: 0.7, delay: 0.3 }}
                      viewport={{ once: true }}
                      className="relative inline-block">
                      {/* Glowing backdrop */}
                      <div className="absolute -inset-3 gold-gradient-bg blur-xl opacity-50"></div>
                      {/* Code box */}
                      <div className="relative bg-[#0B0B0B] px-8 py-6" style={{ border: '2px dashed #D4AF37' }}>
                        <p className="text-2xl md:text-3xl font-bold tracking-[0.3em] gold-gradient-text">
                          GORUKLEVIP20
                        </p>
                      </div>
                    </motion.div>

                    <p className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mt-4">
                      Tıkla, kopyala, randevuna kullan
                    </p>
                  </div>

                  <div className="space-y-3">
                    <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Merhaba, %20 indirim hediye kuponumdan yararlanmak istiyorum. Kod: GORUKLEVIP20')}`} target="_blank" rel="noopener noreferrer" className="block">
                      <button className="w-full gold-gradient-bg text-[#0B0B0B] px-8 py-4 font-bold tracking-[0.18em] uppercase text-xs hover:opacity-90 transition-all duration-300 inline-flex items-center justify-center gap-3 shadow-lg" data-testid="coupon-cta">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                        </svg>
                        Kuponu Hemen Kullan
                        <ChevronRight size={14} />
                      </button>
                    </a>
                    <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Merhaba, sevdiğim biri için hediye kuponu satın almak istiyorum.')}`} target="_blank" rel="noopener noreferrer" className="block">
                      <button className="w-full bg-transparent border border-[#D4AF37] text-[#D4AF37] px-8 py-4 font-semibold tracking-[0.18em] uppercase text-xs hover:bg-[#D4AF37] hover:text-[#0B0B0B] transition-all duration-300 inline-flex items-center justify-center gap-3" data-testid="gift-cta">
                        <Gift size={16} />
                        Hediye Olarak Gönder
                      </button>
                    </a>
                  </div>

                  <p className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mt-6 text-center">
                    * Kampanya sınırlı süreyle geçerlidir
                  </p>
                </div>
              </div>

              {/* Gold accent line bottom */}
              <div className="h-1 gold-gradient-bg"></div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Price List - Premium Liste */}
      <section className="py-14 md:py-28 relative" style={{ backgroundColor: '#FFFFFF' }}>
        {/* Decorative gold radial */}
        <div className="absolute top-0 right-0 w-[400px] h-[400px] opacity-20 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.3) 0%, transparent 70%)' }}></div>

        <div className="max-w-4xl mx-auto px-5 md:px-12 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-3 mb-4">
              <div className="w-10 h-px gold-gradient-bg"></div>
              <span className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text">
                Fiyat Listesi
              </span>
              <div className="w-10 h-px gold-gradient-bg"></div>
            </div>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Hizmet <span className="gold-gradient-text font-medium">Ücretlerimiz</span>
            </h2>
          </motion.div>

          {/* Price card */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
            className="relative bg-white shadow-2xl"
            style={{ border: '1px solid rgba(212, 175, 55, 0.4)' }}>

            {/* Top gold bar */}
            <div className="h-1.5 gold-gradient-bg"></div>

            {/* Header inside card */}
            <div className="text-center py-8 md:py-10 px-6 md:px-10 border-b" style={{ borderColor: 'rgba(212, 175, 55, 0.25)' }}>
              <div className="flex items-center justify-center gap-3 mb-2">
                <Sparkles size={14} className="text-[#D4AF37]" />
                <p className="text-[10px] md:text-xs tracking-[0.4em] uppercase gold-gradient-text font-bold">
                  Premium Masaj Hizmetleri
                </p>
                <Sparkles size={14} className="text-[#D4AF37]" />
              </div>
              <p className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#737373]">
                Tüm fiyatlara KDV dahildir
              </p>
            </div>

            {/* Price rows */}
            <div className="p-6 md:p-10">
              {[
                // 40 DAKİKA
                { category: '40 Dakika', name: 'Klasik Masaj', subtitle: 'Geleneksel İsveç Tekniği', duration: '40 dk', oldPrice: '1.700', price: '1.500' },
                { name: 'Soft Masaj', subtitle: 'Zarif Dokunuş & Aroma', duration: '40 dk', oldPrice: '2.700', price: '2.500' },
                { name: 'Mix Masaj', subtitle: 'Çoklu Teknik Bütünleşmesi', duration: '40 dk', oldPrice: '2.700', price: '2.500' },
                // 60 DAKİKA
                { category: '60 Dakika', name: 'Klasik Masaj', subtitle: 'Geleneksel İsveç Tekniği', duration: '60 dk', oldPrice: '2.000', price: '1.800' },
                { name: 'Soft Masaj', subtitle: 'Zarif Dokunuş & Aroma', duration: '60 dk', oldPrice: '3.000', price: '2.800' },
                { name: 'Mix Masaj', subtitle: 'Çoklu Teknik Bütünleşmesi', duration: '60 dk', oldPrice: '3.000', price: '2.800' },
                // ÖZEL TERAPİLER
                { category: 'Özel Terapiler', name: 'Kupa Terapi', subtitle: 'Vakum Detoks Tekniği', duration: 'Seans', price: '2.500' },
                { name: 'Aroma Terapi', subtitle: 'Esansiyel Yağ Ritüeli', duration: 'Seans', price: '2.500' },
                { name: 'Sultan Masajı', subtitle: 'Premium Tam Vücut Deneyimi', duration: 'Seans', price: '3.500', highlight: true }
              ].map((item, idx, arr) => (
                <React.Fragment key={idx}>
                  {/* Category header */}
                  {item.category && (
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      transition={{ duration: 0.5 }}
                      viewport={{ once: true }}
                      className={`flex items-center gap-3 ${idx === 0 ? 'pb-3' : 'pt-6 pb-3'}`}>
                      <div className="w-6 h-px gold-gradient-bg"></div>
                      <span className="text-[10px] md:text-xs tracking-[0.4em] uppercase gold-gradient-text font-bold">
                        {item.category}
                      </span>
                      <div className="flex-1 h-px bg-[#D4AF37]/15"></div>
                    </motion.div>
                  )}
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: (idx % 3) * 0.08 }}
                    viewport={{ once: true }}
                    className={`flex items-center justify-between gap-4 py-3.5 md:py-4 ${idx !== arr.length - 1 && !arr[idx + 1]?.category ? 'border-b' : ''} ${item.highlight ? 'relative' : ''}`}
                    style={{ borderColor: 'rgba(212, 175, 55, 0.12)' }}>

                    {/* Left: name + subtitle */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1 flex-wrap">
                        <h4 className="text-sm md:text-lg font-medium text-[#0B0B0B] tracking-wide">
                          {item.name}
                        </h4>
                        {item.highlight && (
                          <span className="text-[8px] md:text-[9px] tracking-[0.2em] uppercase gold-gradient-bg text-[#0B0B0B] px-2 py-0.5 font-bold">
                            ★ Premium
                          </span>
                        )}
                      </div>
                      <p className="text-[10px] md:text-xs text-[#737373] tracking-wide">
                        {item.subtitle}
                      </p>
                    </div>

                    {/* Middle: duration (hidden mobile) */}
                    <div className="hidden md:block flex-shrink-0">
                      <span className="text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3] border border-[#D4AF37]/30 px-3 py-1">
                        {item.duration}
                      </span>
                    </div>

                    {/* Right: price */}
                    <div className="text-right flex-shrink-0">
                      <div className="md:hidden text-[9px] tracking-[0.2em] uppercase text-[#A3A3A3] mb-1">
                        {item.duration}
                      </div>
                      <div className="flex items-baseline gap-2 justify-end">
                        {item.oldPrice && (
                          <span className="text-xs md:text-sm text-[#A3A3A3] line-through font-light">
                            {item.oldPrice}
                          </span>
                        )}
                        <div className="flex items-baseline gap-1">
                          <span className="text-xl md:text-2xl font-medium gold-gradient-text leading-none">
                            {item.price}
                          </span>
                          <span className="text-xs md:text-sm font-light text-[#525252]">₺</span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </React.Fragment>
              ))}
            </div>

            {/* Bottom info bar */}
            <div className="bg-[#FAFAFA] py-5 md:py-6 px-6 md:px-10 text-center border-t" style={{ borderColor: 'rgba(212, 175, 55, 0.25)' }}>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <Gift size={14} className="text-[#D4AF37]" />
                <span className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#525252]">
                  İlk randevuda <span className="gold-gradient-text font-bold">%20 indirim</span> · Kod: <span className="font-bold text-[#0B0B0B]">GORUKLEVIP20</span>
                </span>
              </div>
            </div>

            {/* Bottom gold bar */}
            <div className="h-1.5 gold-gradient-bg"></div>
          </motion.div>

          {/* CTA */}
          <div className="text-center mt-10 md:mt-12">
            <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Merhaba, kampanyalı fiyatlardan yararlanmak ve randevu almak istiyorum.')}`} target="_blank" rel="noopener noreferrer">
              <button className="gold-gradient-bg text-[#0B0B0B] px-10 py-4 md:px-12 md:py-5 font-bold tracking-[0.18em] uppercase text-xs md:text-sm hover:opacity-90 transition-all duration-300 shadow-lg inline-flex items-center justify-center gap-3" data-testid="price-cta">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
                </svg>
                Hemen Randevu Al
                <ChevronRight size={14} />
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Reviews - Premium Testimonials */}
      <section className="py-14 md:py-28" style={{ backgroundColor: '#FAFAFA', borderTop: '1px solid rgba(212, 175, 55, 0.2)', borderBottom: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div className="max-w-5xl mx-auto px-5 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12 md:mb-16">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text mb-4">
              Misafir Yorumları
            </p>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase mb-4">
              Onların Sözleriyle
            </h2>
            <div className="flex items-center justify-center gap-2 mt-6">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="fill-[#D4AF37] text-[#D4AF37]" size={18} />
              ))}
              <span className="text-sm tracking-wider text-[#525252] ml-2">5.0 / {reviews.length}+ Yorum</span>
            </div>
          </motion.div>

          <motion.div
            key={currentReview}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="relative bg-white p-7 md:p-14 shadow-xl"
            style={{ border: '1px solid rgba(212, 175, 55, 0.3)' }}>
            {/* Gold corner decorations */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-[#D4AF37]"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-[#D4AF37]"></div>

            {/* Big quote */}
            <div className="text-center">
              <div className="text-7xl md:text-8xl gold-gradient-text leading-none mb-4 font-serif">"</div>

              <p className="text-base md:text-xl font-light leading-[1.9] text-[#0B0B0B] italic mb-8 max-w-3xl mx-auto">
                {reviews[currentReview].comment}
              </p>

              <div className="flex items-center justify-center gap-1 mb-4">
                {[...Array(reviews[currentReview].rating)].map((_, i) => (
                  <Star key={i} className="fill-[#D4AF37] text-[#D4AF37]" size={16} />
                ))}
              </div>

              {/* Avatar circle with initials */}
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full gold-gradient-bg flex items-center justify-center text-[#0B0B0B] font-bold text-sm tracking-wider">
                  {reviews[currentReview].name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#0B0B0B]">
                    {reviews[currentReview].name}
                  </p>
                  <p className="text-[10px] tracking-[0.3em] uppercase text-[#737373] mt-1">
                    Doğrulanmış Misafir
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-10">
            <button
              onClick={() => setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length)}
              className="w-10 h-10 border border-[#D4AF37] flex items-center justify-center hover:gold-gradient-bg hover:border-transparent transition-all duration-300 group"
              aria-label="Önceki yorum"
              data-testid="prev-review">
              <ChevronRight size={16} className="text-[#D4AF37] group-hover:text-[#0B0B0B] rotate-180 transition-colors" />
            </button>

            <div className="text-sm tracking-[0.3em] uppercase text-[#525252] tabular-nums">
              <span className="text-[#0B0B0B] font-medium">{String(currentReview + 1).padStart(2, '0')}</span>
              <span className="mx-2">/</span>
              <span>{String(reviews.length).padStart(2, '0')}</span>
            </div>

            <button
              onClick={() => setCurrentReview((prev) => (prev + 1) % reviews.length)}
              className="w-10 h-10 border border-[#D4AF37] flex items-center justify-center hover:gold-gradient-bg hover:border-transparent transition-all duration-300 group"
              aria-label="Sonraki yorum"
              data-testid="next-review">
              <ChevronRight size={16} className="text-[#D4AF37] group-hover:text-[#0B0B0B] transition-colors" />
            </button>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-16 md:py-28" style={{ backgroundColor: '#FFFFFF', borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase gold-gradient-text mb-4">
              İletişim
            </p>
            <h2 className="text-2xl md:text-5xl font-extralight tracking-wide text-[#0B0B0B] uppercase">
              Bize Ulaşın
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-16">
            <div className="space-y-8">
              <div className="flex items-center gap-6">
                <div className="w-12 h-12 gold-gradient-bg flex items-center justify-center">
                  <Phone className="text-[#0B0B0B]" size={20} />
                </div>
                <div>
                  <h4 className="text-sm font-medium tracking-[0.2em] uppercase text-[#737373] mb-2">Telefon</h4>
                  <a href={`tel:${telNumber}`} className="text-lg text-[#0B0B0B] hover:text-[#D4AF37] transition-colors">
                    {phoneNumber}
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-6">
                <div className="w-12 h-12 gold-gradient-bg flex items-center justify-center">
                  <Instagram className="text-[#0B0B0B]" size={20} />
                </div>
                <div>
                  <h4 className="text-sm font-medium tracking-[0.2em] uppercase text-[#737373] mb-2">Instagram</h4>
                  <a href={`https://instagram.com/${businessInstagram}`} target="_blank" rel="noopener noreferrer" className="text-lg text-[#0B0B0B] hover:text-[#D4AF37] transition-colors">
                    @{businessInstagram}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="w-12 h-12 gold-gradient-bg flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-[#0B0B0B]" size={20} />
                </div>
                <div>
                  <h4 className="text-sm font-medium tracking-[0.2em] uppercase text-[#737373] mb-2">Adres</h4>
                  <p className="text-base text-[#0B0B0B] leading-relaxed">
                    Oruç Plus, Dumlupınar<br />
                    Selanik Cd. Kat:1 No:2<br />
                    16285 Nilüfer/Bursa
                  </p>
                </div>
              </div>
            </div>

            <div className="h-[500px] overflow-hidden" style={{ border: '1px solid rgba(212, 175, 55, 0.4)' }}>
              <iframe
                src="https://maps.google.com/maps?q=Pure+Life+Masaj+Salonu+G%C3%B6r%C3%BCkle+Bursa&t=&z=16&ie=UTF8&iwloc=B&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Pure Life Görükle Masaj Salonu - Konum">
              </iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16" style={{ backgroundColor: '#0B0B0B', borderTop: '2px solid #D4AF37' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-12">
          <div className="text-center">
            <h3 className="text-2xl font-light tracking-wide text-white uppercase mb-4">
              Görükle Masaj Salonu
            </h3>
            <p className="text-sm text-[#A3A3A3] mb-6">
              Premium Masaj Salonu · Bursa Görükle
            </p>
            <div className="flex justify-center gap-6 mb-8">
              <a href={`https://wa.me/${whatsappNumber}`} target="_blank" rel="noopener noreferrer" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                <MessageCircle size={20} />
              </a>
              <a href={`https://instagram.com/${businessInstagram}`} target="_blank" rel="noopener noreferrer" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                <Instagram size={20} />
              </a>
              <a href={`tel:${telNumber}`} className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
                <Phone size={20} />
              </a>
            </div>
            <p className="text-xs text-[#A3A3A3]">
              © 2024 Görükle Masaj Salonu. Tüm hakları saklıdır.
            </p>
            <div className="mt-6 pt-6 border-t border-[#D4AF37]/20">
              <a
                href="https://banabimedia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#A3A3A3] hover:text-[#D4AF37] transition-colors"
                data-testid="banabimedia-link"
                aria-label="Bana Bi Media">
                <span>Project</span>
                <span className="w-px h-3 bg-[#D4AF37]/40"></span>
                <span className="font-semibold gold-gradient-text">Bana Bi Media</span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
